import { cn } from "@/utils/cn";
import React from "react";
import { Button } from "./button";

interface LoadingButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isLoading?: boolean;
  loadingText?: string;
  label: string;
  variant?: "dark" | "accent" | "outline" | "ghost";
}

/**
 * @deprecated Use `Button` from `src/components/ui/button.tsx` with `isLoading` instead.
 */
export function LoadingButton({
  isLoading: isConfirming = false,
  loadingText: confirmText,
  label,
  className,
  disabled,
  variant = "accent",
  ...props
}: LoadingButtonProps) {
  return (
    <Button
      variant={variant}
      disabled={disabled || isConfirming}
      className={cn(
        "grid place-items-center [grid-template-areas:'stack'] disabled:opacity-70",
        className,
      )}
      {...props}
    >
      <div
        className={cn(
          "invisible h-6 [grid-area:stack]",
          isConfirming && "visible",
        )}
      >
        {confirmText ?? " Confirming..."}
      </div>

      <span
        className={cn("visible [grid-area:stack]", isConfirming && "invisible")}
      >
        {label}
      </span>
    </Button>
  );
}
